import { useState, useEffect } from "react";
import Select from 'react-select'

const CboTurno = ({ selectedValue, onChange, disabled, grupo, empresa, className }) => {

  const [turnos, setTurnos] = useState([])

  useEffect(() => {

    var json3;
    var jsons3;
    var url3;
    let consulta = new Object();

    consulta.grupo = grupo;
    consulta.empresa = empresa;

    jsons3 = JSON.stringify(consulta);


    var options3 = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'

      },
      mode: 'cors',
      credential: 'include',
      body: jsons3,

    };

    url3 = `${process.env.REACT_APP_API_URL}/tur/allturnos`;



    fetch(url3, options3)
      .then(response => response.json())
      .then(data => {

        json3 = data;
        console.log("Turnos:", data);
        setTurnos(json3.data);

        if (json3.data.length > 0) {
          var primerId;
          if (selectedValue) {
            primerId = selectedValue;
          }
          else {
            primerId = json3.data[0].Tur_IdTur;
          }
          const eventoSimulado = {
            target: {
              value: primerId
            }
          };
          onChange(eventoSimulado);
        }



      })


  }, [empresa]);

  const opcionesTurnos = [
    { value: 0, label: 'todos los turnos' },

    ...turnos.map((unolista) => ({
      value: unolista.Tur_IdTur,
      label: unolista.Tur_Nombre
    }))
  ];
  const turnoSeleccionado =
    opcionesTurnos.find(op => op.value === selectedValue);


  return (

    <div className={"col-lg-offset-0 col-lg-2 col-xs-12 col-sm-4"}>
      <div className="form-group">
        <label className="l" >Turno</label>

        <Select
          classNamePrefix="miSelect"
          isSearchable={false}
          options={opcionesTurnos}
          value={turnoSeleccionado}
          onChange={(opcion) =>
            onChange({
              target: {
                value: opcion?.value || 0
              }
            })
          }
          isDisabled={disabled}
        />



      </div>
    </div>
  );
};

export default CboTurno;